module.exports = __webpack_public_path__ + "static/img/super-chat-pass.c064bbdd.png";